import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle
} from '~/common/components/ui/alert-dialog';
import { LoginButton } from '~/shell/components/LoginButton';
import { useTranslation } from 'react-i18next';
import { useBasePath } from '~/common/hooks/useBasePath';
import { useFetcher } from 'react-router';
import { useEffect } from 'react';
import { captureError } from '~/tracking/logger.ts';

export function UnauthorizedDialogDisplay({ dialogOpen }: Readonly<{ dialogOpen: boolean }>) {
  const { t } = useTranslation();
  const { path: basePath } = useBasePath();
  const fetcher = useFetcher();

  useEffect(() => {
    if (dialogOpen) {
      captureError('Login expired: The dialog `UnauthorizedDialogDisplay` is shown to the user!');
    }
  }, [dialogOpen]);

  return (
    <AlertDialog open={dialogOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t('Login abgelaufen!')}</AlertDialogTitle>
          <AlertDialogDescription>{t('Bitte melden Sie sich erneut an, um fortzufahren.')}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <fetcher.Form method={'POST'} action={'/infra/auth/logout'}>
            <input type="hidden" name="redirectTo" value={basePath} />
            <AlertDialogCancel type="submit" data-testid={'cart-logout-button'}>{t('Abbrechen')}!</AlertDialogCancel>
          </fetcher.Form>
          <LoginButton />
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
